import { createPrefixer } from '.'

const ROOT = 'ver-tributacion-pg' as const
export const RESOURCE_TRIBUTACION_PG = 'Tributacion PG' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')
const pt = createPrefixer(ROOT, 'transacciones')
const prdep = createPrefixer(ROOT, 'transacciones-rdep')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_TRIBUTACION_PG,
    mantenimiento: {
        _perm: rp('mantenimiento'),
        paises: pm('paises'),
        distritoAduanero: pm('distrito-aduanero'),
        fideicomiso: pm('fideicomiso'),
        formaPagoCobro: pm('forma-pago-cobro'),
        sustentoTributario: pm('sustento-tributario'),
        retencionIVA: pm('retencion-iva'),
        exportaciones: pm('exportaciones'),
        provincias: pm('provincias'),
        ciudades: pm('ciudades'),
        comprobante: pm('comprobante'),
        puntoEmision: pm('punto-emision'),
        regimenFiscal: pm('regimen-fiscal'),
        codigoFormulario104: pm('codigo-formulario-104'),
        politicaIVA: pm('politica-iva'),
        tipoContribuyente: pm('tipo-contribuyente'),
        gestionPartidasArancelarias: pm('gestion-partidas-arancelarias'),
        paraisoFiscal: pm('paraiso-fiscal'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        transaccionTributaria: pc('transaccion-tributaria'),
        comprobanteAutorizado: pc('comprobante-autorizado'),
        parametrosRdep: pc('parametros-rdep'),
        conceptosRetencionFuente: pc('conceptos-retencion-fuente'),
        camposFormulario103: pc('campos-formulario-103'),
        cierreSRI: pc('cierre-sri'),
        matrizTipoContribuyente: pc('matriz-tipo-contribuyente'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        rdep: {
            _perm: rp('transacciones-rdep'),
            migrarExcelRDEP: prdep('migrar-excel'),
            generarXmlRDEP: prdep('generar-xml'),
        },
        generarXmlATS: pt('generar-xml-ats'),
        documentoRetencion: pt('documento-retencion'),
        solicitudAnulacionDocElectronicos: pt('solicitud-anulacion-documentos-electronicos'),
    },
    informes: {
        _perm: rp('informes'),
        reporte103: pi('reporte-103'),
        reporte104: pi('reporte-104'),
        reporte107: pi('reporte-107'),
        excelComprasServicios: pi('excel-compras-servicios'),
        reporteTabuladoRDEP: pi('reporte-tabulado-rdep'),
        reporteControlErrorUsuarioContable: pi('reporte-control-error-usuario-contable'),
        atsImportacion: pi('ats-importacion'),
    },
}

export default permission
